import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    // Track SPA page views in Google Analytics (GA4)
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-WLBXX3SKXS', {
        page_path: pathname + search,
      });
    }
  }, [pathname, search]);

  return null;
};

export default ScrollToTop; 